// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import merge from 'lodash.merge';
import memoize from 'lodash.memoize';
// memoize.Cache = WeakMap;
import { getActions } from './calculations.actions';
const memoizedActions = {
    get: function (key) {
        if (this[key]) {
            return this[key];
        }
        const memoizedActionFn = memoize(getActions[key], (state) => {
            return JSON.stringify({ inputs: state?.inputs });
        });
        this[key] = memoizedActionFn;
        return memoizedActionFn;
    },
};
const positionsRegex = /(\[-[\d]\])/g;
const removeBrasketRegex = /[[\]]/g;
export const stateAccess = (state, dispatch, status, setStatus, inputs) => {
    const getFullKey = (path, key) => {
        return `${path}${path ? '.' : ''}${key.replace(path, '')}`;
    };
    const getStateValues = ({ lookupKey, path = '', states, }) => {
        if (Array.isArray(lookupKey)) {
            return lookupKey.map((key) => {
                return getStateValue(getFullKey(path, key), states);
            });
        }
        else {
            return getStateValue(getFullKey(path, lookupKey), states);
        }
    };
    const getStateValue = (key, states) => {
        const getOrDispatchResult = (key) => {
            if (key.includes('status')) {
                return get({ status }, key);
            }
            const value = get(state, `results.${key}`);
            if (value !== undefined) {
                return value;
            }
            else {
                const actionKey = states === 'all'
                    ? Object.keys(getActions)
                    : states ||
                        Object.keys(getActions).find((action) => key.includes(action));
                let payload = undefined;
                let fromCache = false;
                if (actionKey && Array.isArray(actionKey)) {
                    payload = actionKey.reduce((acc, key) => {
                        const actionFn = memoizedActions.get(key);
                        fromCache = actionFn.cache.has(JSON.stringify({ inputs: state?.inputs }));
                        return merge(acc || {}, actionFn(state, setStatus, inputs));
                    }, undefined);
                }
                else if (actionKey) {
                    const actionFn = memoizedActions.get(actionKey);
                    fromCache = actionFn.cache.has(JSON.stringify({ inputs: state?.inputs }));
                    payload = actionFn(state, setStatus, inputs);
                }
                if (payload && !fromCache) {
                    Promise.resolve(payload).then((results) => {
                        dispatch({ type: 'results', payload: results });
                    });
                }
            }
        };
        if (key.match(positionsRegex)) {
            const keyPieces = key.split(positionsRegex);
            const completeKey = keyPieces.reduce((acc, el) => {
                if (!el.match(positionsRegex)) {
                    return acc + el;
                }
                else {
                    // TODO: error handling here
                    const arr = getOrDispatchResult(acc);
                    if (arr && Array.isArray(arr)) {
                        const position = parseInt(el.replaceAll(removeBrasketRegex, ''));
                        return acc + `[${arr.length + position}]`;
                    }
                    return '';
                }
            }, '');
            return getOrDispatchResult(completeKey);
        }
        else {
            return getOrDispatchResult(key);
        }
    };
    return getStateValues;
};
